/** Shared API base for LOOP host. */
function resolveApiBase(): string {
  if (typeof window !== 'undefined') {
    const override = (window as unknown as { __RS_API__?: string }).__RS_API__;
    if (override) return override;
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:5002';
    return 'https://api.restrosync.com';
  }
  return 'https://api.restrosync.com';
}

export const API_BASE_URL = resolveApiBase();

let currentToken = '';

export function getApiToken(): string {
  return currentToken;
}

export function setApiToken(token: string | null): void {
  currentToken = token?.trim() || '';
}

export async function api<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const headers = new Headers(init.headers || {});
  if (!headers.has('Content-Type') && init.body) {
    headers.set('Content-Type', 'application/json');
  }
  const token = getApiToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);
  const ctrl = new AbortController();
  const ms = path.includes('/loop/insights') ? 120_000 : 60_000;
  const timer = setTimeout(() => ctrl.abort(), ms);
  try {
    const res = await fetch(`${API_BASE_URL}${path}`, {
      ...init,
      headers,
      signal: init.signal || ctrl.signal,
    });
    const body = await res.json().catch(() => ({}));
    if (!res.ok || body?.success === false) {
      const msg = body?.error?.message || `Request failed (${res.status})`;
      const err = new Error(msg) as Error & { status?: number; code?: string };
      err.status = res.status;
      err.code = body?.error?.code;
      throw err;
    }
    return (body?.data !== undefined ? body.data : body) as T;
  } catch (e) {
    if (e instanceof Error && e.name === 'AbortError') {
      throw new Error('Insights took too long — retry or narrow the period');
    }
    throw e;
  } finally {
    clearTimeout(timer);
  }
}
